/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useModal } from "../../../context/ModalContext";
import { CloseIcon, PaymentOverdueIcon } from "../../../components/Icons";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import GvSecondaryButton from "../../../components/GvSecondaryButton/GvSecondaryButton";
import { useNavigate } from "react-router-dom";
import { MODALS } from "../../../config/params";
import { useOverdueInvoiceStore } from "../../../hooks/redux-hooks/overdue-invoice-store/overdue-invoice.store";
import { PAGES_PATH } from "../../../navigation/params";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { userActivityLogger } from "../../../utils/mixpanel";

const PendingInvoicePausedAlertModal = () => {
  const { openModal, closeModal, source } = useModal();
  const { pausedWellnessPetList } = useOverdueInvoiceStore();
  const navigate = useNavigate();
  const isAlreadyOnBillingPage = window.location.href.includes(PAGES_PATH.USER_BILLING);

  const handlePayNowCta = () => {
    if (pausedWellnessPetList.length > 1) {
      if (isAlreadyOnBillingPage) {
        closeModal();
      } else {
        // navigate to billing
        navigate("/user-profile/payment");
        //  multiple pets pay now clicked
        pausedWellnessPetList.forEach((petData) => {
          userActivityLogger(MIXPANEL_EVENTS.PAY_NOW_CLICKED,
            {
              pet_name: petData.petName,
              referred_from_page: "pending_overdue_invoice",
              due_amount: `${petData.dueAmount}`,
              invoice_due_date: petData.invoiceDueDate,
            });
        });
      }
    } else if (pausedWellnessPetList.length == 1) {
      userActivityLogger(MIXPANEL_EVENTS.PAY_NOW_CLICKED,
        {
          pet_name: pausedWellnessPetList[0].petName,
          referred_from_page: "pending_overdue_invoice",
          due_amount: `${pausedWellnessPetList[0].dueAmount}`,
          invoice_due_date: pausedWellnessPetList[0].invoiceDueDate,
        });
      window.open(pausedWellnessPetList[0].publicUrl);
    }
  };


  const handleCta = () => {
    openModal(MODALS.OVERDUE_CONTACT_MODAL);
    userActivityLogger(MIXPANEL_EVENTS.CONTACT_HOSPITAL_TRIGGERED, {
      referred_from: "payment_overdue_pop_up",
    });
  };

  const handleModalClose =(closeFromParent?: "closeIcon") =>{
    if (closeFromParent === "closeIcon") {
      userActivityLogger(MIXPANEL_EVENTS.PAYMENT_OVERDUE_DISMISSED, {});
    }
    closeModal();
  };


  return (
    <>
      <div className="flex flex-col w-full xl:w-[24rem]">
        <div className="flex justify-end">
          <CloseIcon
            onClick={()=>handleModalClose("closeIcon")}
            className="text-light-black cursor-pointer"
          />
        </div>
        <div className="w-full flex flex-col items-center gap-3">
          <div>
            <PaymentOverdueIcon width={72} height={72} />
          </div>
          <div className="text-xl font-semibold text-center w-80">
              Payments Overdue
          </div>
          <div className="flex flex-col w-full">
            <div className="flex justify-center mb-4">
              <div className="text-center">
                {`${source === PAGES_PATH.PET_CARE ?
                  `Please pay the outstanding balance on Testpet Cat's wellness plan. 
                  Without clearing this balance, you will not be able to purchase new wellness plans.` :
                  "Please pay your overdue wellness plan invoice to book an appointment."}`}
              </div>
            </div>
            <StyledBookingFlowButton
              disabled={false}
              fullWidth
              color="primary"
              className="!text-sm"
              size="small"
              onClick={()=>handlePayNowCta()}
            >
                  Pay Now
            </StyledBookingFlowButton>
            <div className="w-full">
              <GvSecondaryButton
                type="button"
                onClick={handleCta}
                className="!w-full !font-semibold !border-1 !border-gray-4 hover:!bg-gray-3 !h-[2.5rem] !text-sm"
              >
                  Contact Hospital
              </GvSecondaryButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingInvoicePausedAlertModal;
